import React, { useState, useRef } from 'react';
import { FaUpload, FaDownload, FaFileUpload } from 'react-icons/fa';
import { toast } from 'react-toastify';

function UploadButton({ onUpload }) {
  const [showMenu, setShowMenu] = useState(false);
  const fileInputRef = useRef(null);
  
  const handleDownloadTemplate = () => {
    // JSON template with example items
    const templateData = [
      {
        "title": "Example Prompt",
        "description": "A description of what this prompt does",
        "content": "The actual prompt content goes here",
        "category": "General"
      },
      {
        "title": "Another Example",
        "description": "Optional description",
        "content": "More prompt content",
        "category": "Unassigned"
      }
    ];
    
    const blob = new Blob([JSON.stringify(templateData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'prompt-template.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    setShowMenu(false);
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const reader = new FileReader();
        reader.onload = async (event) => {
          try {
            const contentItems = JSON.parse(event.target.result);
            

            if (!Array.isArray(contentItems)) {
              toast.error('File must contain an array of prompts');
              return;
            }

            if (contentItems.length === 0) {
              toast.error('File contains an empty array');
              return;
            }

            // Validate and transform items
            const validItems = contentItems.map(item => {
              if (!item.content) {
  
              }
              return {
                title: item.title || 'Untitled',
                description: item.description || '',
                content: item.content || '',
                category: item.category || 'Unassigned'
              };
            }).filter(item => {
              const isValid = Boolean(item.content);
              if (!isValid) {
  
              }
              return isValid;
            });


            
            if (validItems.length === 0) {
              toast.error('No valid items found. Each item must have content.');
              return;
            }

            onUpload(validItems);
            toast.success(`Found ${validItems.length} valid items to import`);
          } catch (error) {
            console.error('JSON parsing error:', error);
            toast.error(`Invalid JSON format: ${error.message}`);
          }
        };
        reader.readAsText(file);
        setShowMenu(false);
      } catch (error) {
        console.error('File reading error:', error);
        toast.error(`Failed to read file: ${error.message}`);
      }
    }
    fileInputRef.current.value = ''; // Reset file input
  };

  return (
    <div className="upload-button-container">
      <button
        className="action-button upload-button"
        onClick={() => setShowMenu(!showMenu)}
      >
        <FaUpload /> Import
      </button>
      
      {showMenu && (
        <div className="upload-menu">
          <button onClick={handleDownloadTemplate}>
            <FaDownload /> Download Template
          </button>
          <label className="upload-option">
            <FaFileUpload /> Upload JSON
            <input
              ref={fileInputRef}
              type="file"
              accept=".json"
              onChange={handleFileSelect}
              style={{ display: 'none' }}
            />
          </label>
        </div>
      )}
    </div>
  );
}

export default UploadButton; 